export default __webpack_public_path__ + "static/media/sip.35ffde87.svg";